
































import Vue, { PropType } from 'vue'
import { Admin } from '@/models/Admin'
export default Vue.extend({
  props: {
    admin: {
      type: Object as PropType<Admin>,
      required: true
    },
    isAcceptable: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  }
})
